<template>
    <b-row class="m-0 p-0 g-0">
        <b-col md="3" class="ml-0 p-0 d-none d-sm-block">
            <b-list-group>
                <b-list-group-item href="/inbox/message"><font-awesome-icon :icon="['fa-solid', 'fa-address-book']" />
                    Personal Inbox</b-list-group-item>
                <b-list-group-item href="/reminders"><font-awesome-icon :icon="['fa-solid', 'fa-clock']" />
                    Reminders</b-list-group-item>
                <b-list-group-item>
                    <a v-if="is_admin == 1" href="/inbox/create" class="float-right"><font-awesome-icon
                            :icon="['fa-solid', 'fa-plus']" /></a>
                    <strong><font-awesome-icon :icon="['fa-solid', 'fa-angle-down']" />
                        Inboxes</strong></b-list-group-item>
                <div v-for="inbox in subscriptions" :key="'inbox-' + inbox.inbox_id">
                    <b-list-group-item v-if="inbox.type != 'dm'"
                        :href="`/inbox/message/${inbox.inbox_id}`"><font-awesome-icon :icon="['fas', 'people-group']" />
                        {{ inbox.subject }}</b-list-group-item>
                </div>
                <b-list-group-item>
                    <a href="/inbox/dm/create" class="float-right"><font-awesome-icon
                            :icon="['fa-solid', 'fa-plus']" /></a>
                    <strong><font-awesome-icon :icon="['fa-solid', 'fa-angle-down']" />
                        Direct Messages</strong></b-list-group-item>
                <div v-for="inbox in subscriptions" :key="'dm-' + inbox.inbox_id">
                    <b-list-group-item v-if="inbox.type == 'dm'"
                        :href="`/inbox/message/${inbox.inbox_id}`"><font-awesome-icon :icon="['fas', 'user']"
                            class="px-1" /> {{ inbox.subject }}</b-list-group-item>
                </div>
            </b-list-group>
        </b-col>
        <b-col md="9" class="p-2">
            <b-alert variant="light border-bottom-1" :show="inbox.id !== null">
                <span class="float-right" v-if="inbox.subject !== 'direct' && is_admin == 1"><a
                        :href="`/inbox/${inbox.id}/edit`">Edit</a></span>
                <font-awesome-icon :icon="['fa-solid', 'fa-message']" /> {{ title }}</b-alert>
            <div id="chatlog" :style="`height:${height}px; overflow-y:auto; overflow-x:auto;`">
                <b-card deck no-body class="overflow-hidden border-0" v-for="item in items" :key="item.id"
                    style="border-bottom: 1px solid #EEE !important">
                    <b-row no-gutters class="p-2">
                        <b-col cols="1">
                            <b-card-img :src="item.avatar" fluid class="rounded-0 ml-2"></b-card-img>
                        </b-col>
                        <b-col cols="11">
                            <b-card-body class="py-0 pr-0 overflow-hidden" style="max-width: 800px;">
                                <b-card-text><strong><a :href="`/user/${item.author_id}`">{{ item.author
                                            }}</a></strong> <span class="text-muted">{{ item.created_at | fullDate
                                        }}</span></b-card-text>
                                <b-card-text v-html="item.reply"></b-card-text>

                                <!-- Display existing reactions -->
                                <div class="reactions-display mb-2" v-if="item.reactions && Object.keys(item.reactions).length > 0">
                                    <b-badge
                                        v-for="(reaction, type) in item.reactions"
                                        :key="type"
                                        :variant="reaction.currentUserReacted ? 'primary' : 'light'"
                                        pill
                                        class="reaction-badge mr-1"
                                        @click="addReaction(item.id, type)"
                                        :title="reaction.users.join(', ')">
                                        <font-awesome-icon :icon="getReactionIcon(type)" />
                                        {{ reaction.count }}
                                    </b-badge>
                                </div>

                                <b-badge variant="light" pill class="p-2 message-actions">
                                    <font-awesome-icon v-if="isMessageOwner(item)" :icon="['fas', 'pen']" class="action-icon" @click="editMessage(item.id)" title="Edit message" />
                                    <font-awesome-icon :icon="['fas', 'heart']" class="action-icon" @click="addReaction(item.id, 'heart')" title="Love" />
                                    <font-awesome-icon :icon="['fas', 'thumbs-up']" class="action-icon" @click="addReaction(item.id, 'thumbs-up')" title="Thumbs up" />
                                    <font-awesome-icon :icon="['fas', 'thumbs-down']" class="action-icon" @click="addReaction(item.id, 'thumbs-down')" title="Thumbs down" />
                                    <font-awesome-icon :icon="['far', 'face-laugh-beam']" class="action-icon" @click="addReaction(item.id, 'laugh')" title="Laugh" />
                                    <font-awesome-icon :icon="['fas', 'triangle-exclamation']" class="action-icon" @click="addReaction(item.id, 'warning')" title="Warning" />
                                    <font-awesome-icon :icon="['fas', 'circle-question']" class="action-icon" @click="addReaction(item.id, 'question')" title="Question" />
                                    <font-awesome-icon v-if="isMessageOwner(item)" :icon="['fas', 'trash-can']" class="action-icon text-danger" @click="deleteMessage(item.id)" title="Delete message" />
                                </b-badge>

                            </b-card-body>
                        </b-col>
                    </b-row>
                </b-card>
            </div>
            <div id="chatbox" class="mx-2">
                <b-alert :show="alert.show" :variant="alert.variant" dismissible @dismissed="alert.show = false">
                    {{ alert.message }}
                </b-alert>
                <b-alert variant="info" :show="editingMessageId !== null" dismissible @dismissed="editingMessageId = null; reply = ''">
                    <font-awesome-icon :icon="['fas', 'pen']" /> Editing message. Click Send to save changes.
                </b-alert>
                <ckeditor :editor="editor" v-model="reply" :config="editorConfig"></ckeditor>
                <b-button variant="primary" class="float-right mt-2" @click="sendReply()" :disabled="isSending">
                    <b-spinner small v-if="isSending"></b-spinner>
                    <font-awesome-icon v-else :icon="['fa-solid', 'fa-message']" />
                    {{ isSending ? 'Sending...' : (editingMessageId ? 'Update Message' : 'Send Reply') }}
                </b-button>
            </div>

        </b-col>
    </b-row>

</template>

<script>

import InboxDataService from "@/services/InboxDataService";
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export default {
    props: ["list"],
    data() {
        return {
            inbox: {
                subject: "Personal Inbox",
                id: 'personal'
            },
            title: "Inbox Messages",
            height: 0,
            items: [],
            subscriptions: [],
            is_admin: localStorage.getItem("admin"),
            fields: [
                { key: "title", label: "Title" },
                { key: "author", label: "Author" },
                { key: "updated_at", label: "Updated" },
            ],
            reply: "",
            editor: ClassicEditor,
            editorData: '<p>Content of the editor.</p>',
            editorConfig: {
                toolbar: {
                    items: [
                        'heading',
                        '|',
                        'bold',
                        'italic',
                        'link',
                        '|',
                        'bulletedList',
                        'numberedList'
                    ]
                },
                language: 'en'
            },
            inboxChannel: null,
            isSending: false,
            alert: {
                show: false,
                variant: '',
                message: ''
            },
            editingMessageId: null,
            retryCount: 0,
            maxRetries: 3
        };
    },
    created() {

        this.setChatHeight();

        InboxDataService.subscribed().then((res) => {
            this.subscriptions = Array.isArray(res) ? res : (Array.isArray(res?.data) ? res.data : []);
        }).catch(() => {})

        if (this.$route.params.id && this.$route.params.id.length === 36) {
            this.inbox.id = this.$route.params.id
        }

        InboxDataService.getInbox(this.inbox.id).then((res) => {

            if (this.inbox.id == 'personal' && res.data === undefined) {

                InboxDataService.create({
                    subject: 'Personal',                    
                    body: '',                    
                    participants: ['self'],
                }).then((res) => {

                    this.inbox = res.data;

                })

            } else {

                this.inbox = res.data
            }

            // set page title
            this.title = `Inbox - ${this.inbox.subject}`

            InboxDataService.getReplies(res.data.id).then((res) => {
                this.items = res.data.reverse();

                // Initialize reactions for all messages
                this.items.forEach(item => {
                    this.initializeMessageReactions(item);
                });

                if (this.inbox.subject == 'direct') {

                    this.items.forEach(item => {
                        if (item.author !== localStorage.getItem('name')) {
                            this.title = `Direct Messages with ${item.author}`
                            // stop processing loop
                            return
                        }
                    })
                }


                setTimeout(() => {
                    this.scrollToBottom();
                }, 100);
            })

            this.inboxChannel = this.$pusher.subscribe(`inbox-${res.data.id}`);
            this.inboxChannel.bind('reply', (data) => {
                this.updateChat(data);
            });

            // Listen for reaction events from other users
            this.inboxChannel.bind('reaction', (data) => {
                this.handleReactionUpdate(data);
            });

        }).catch((err) => {
            // emit vuejs error event
            this.$emit("error", err);
        });
    },

    watch: {
        // title
        title: function () {
            document.title = this.title
        }
    },

    beforeDestroy() {
        // Clean up Pusher subscriptions to prevent memory leaks
        if (this.inboxChannel) {
            this.inboxChannel.unbind('reply');
            this.inboxChannel.unbind('reaction');
            this.$pusher.unsubscribe(`inbox-${this.inbox.id}`);
        }
    },

    methods: {
        setChatHeight() {
            this.height = window.innerHeight - 480
        },

        updateChat(data) {
            this.initializeMessageReactions(data);
            this.items.push(data)
            // sleep for 1 second
            setTimeout(() => {
                this.scrollToBottom();
            }, 100);
        },

        handleReactionUpdate(data) {
            // Handle reaction events from Pusher (from other users)
            const message = this.items.find(item => item.id === data.message_id);
            if (!message) return;

            if (!message.reactions) {
                this.$set(message, 'reactions', {});
            }

            const currentUserName = localStorage.getItem('name');
            const isCurrentUser = data.user_name === currentUserName;

            if (data.action === 'removed') {
                // Remove reaction
                if (message.reactions[data.type]) {
                    message.reactions[data.type].count--;
                    message.reactions[data.type].users = message.reactions[data.type].users.filter(
                        name => name !== data.user_name
                    );
                    if (isCurrentUser) {
                        message.reactions[data.type].currentUserReacted = false;
                    }

                    // Remove reaction type if count is 0
                    if (message.reactions[data.type].count === 0) {
                        this.$delete(message.reactions, data.type);
                    }
                }
            } else {
                // Add reaction
                if (message.reactions[data.type]) {
                    message.reactions[data.type].count++;
                    if (!message.reactions[data.type].users.includes(data.user_name)) {
                        message.reactions[data.type].users.push(data.user_name);
                    }
                    if (isCurrentUser) {
                        message.reactions[data.type].currentUserReacted = true;
                    }
                } else {
                    this.$set(message.reactions, data.type, {
                        count: 1,
                        users: [data.user_name],
                        currentUserReacted: isCurrentUser
                    });
                }
            }
        },

        scrollToBottom() {
            let chatLog = document.getElementById("chatlog");
            chatLog.scrollTop = chatLog.scrollHeight;
        },

        async sendReply(isRetry = false) {
            // Validation
            if (this.reply.length < 3) {
                this.showAlert('danger', 'Reply must be at least 3 characters long');
                return;
            }

            // Prevent multiple simultaneous sends
            if (this.isSending) {
                return;
            }

            this.isSending = true;
            const messageToSend = this.reply;
            const isEditing = this.editingMessageId !== null;

            try {
                if (isEditing) {
                    // Update existing message
                    await InboxDataService.updateMessage(this.inbox.id, this.editingMessageId, { reply: messageToSend });

                    // Update the message in the local array
                    const index = this.items.findIndex(item => item.id === this.editingMessageId);
                    if (index !== -1) {
                        this.items[index].reply = messageToSend;
                    }

                    this.showAlert('success', 'Message updated successfully!');
                    this.editingMessageId = null;
                } else {
                    // Send new message
                    await InboxDataService.reply(this.inbox.id, { reply: messageToSend });
                    this.showAlert('success', 'Message sent successfully!');
                }

                // Clear reply only after successful send/update
                this.reply = '';
                this.retryCount = 0;

                setTimeout(() => {
                    this.alert.show = false;
                }, 2000);

            } catch (error) {
                console.error(`Failed to ${isEditing ? 'update' : 'send'} message:`, error);

                // Retry logic
                if (!isRetry && this.retryCount < this.maxRetries) {
                    this.retryCount++;
                    this.showAlert('warning', `Failed to ${isEditing ? 'update' : 'send'} message. Retrying (${this.retryCount}/${this.maxRetries})...`);

                    // Retry after 1 second
                    setTimeout(() => {
                        this.sendReply(true);
                    }, 1000);
                } else {
                    // Max retries exceeded
                    this.retryCount = 0;
                    this.showAlert('danger', `Failed to ${isEditing ? 'update' : 'send'} message. ${isEditing ? 'The API endpoint may not be implemented yet.' : 'Please try again.'}`);
                }
            } finally {
                this.isSending = false;
            }
        },

        showAlert(variant, message) {
            this.alert = {
                show: true,
                variant: variant,
                message: message
            };
        },

        editMessage(messageId) {
            const message = this.items.find(item => item.id === messageId);
            if (message) {
                // Double-check ownership (UI already prevents this, but extra safety)
                if (!this.isMessageOwner(message)) {
                    this.showAlert('danger', 'You can only edit your own messages.');
                    return;
                }

                this.reply = message.reply;
                this.editingMessageId = messageId;
                this.showAlert('info', 'Editing message. Click Send to save changes.');
            }
        },

        async deleteMessage(messageId) {
            const message = this.items.find(item => item.id === messageId);

            // Double-check ownership (UI already prevents this, but extra safety)
            if (message && !this.isMessageOwner(message)) {
                this.showAlert('danger', 'You can only delete your own messages.');
                return;
            }

            if (!confirm('Are you sure you want to delete this message?')) {
                return;
            }

            try {
                await InboxDataService.deleteMessage(this.inbox.id, messageId);

                // Remove from local array after successful API call
                const index = this.items.findIndex(item => item.id === messageId);
                if (index !== -1) {
                    this.items.splice(index, 1);
                    this.showAlert('success', 'Message deleted successfully!');
                }
            } catch (error) {
                console.error('Failed to delete message:', error);
                this.showAlert('danger', 'Failed to delete message. The API endpoint may not be implemented yet.');
            }
        },

        async addReaction(messageId, reactionType) {
            try {
                const response = await InboxDataService.addReaction(this.inbox.id, messageId, reactionType);

                // Update local UI immediately
                const message = this.items.find(item => item.id === messageId);
                if (message) {
                    if (!message.reactions) {
                        this.$set(message, 'reactions', {});
                    }

                    const currentUserName = localStorage.getItem('name');

                    if (response.data && response.data.action === 'removed') {
                        // Remove reaction
                        if (message.reactions[reactionType]) {
                            message.reactions[reactionType].count--;
                            message.reactions[reactionType].currentUserReacted = false;
                            message.reactions[reactionType].users = message.reactions[reactionType].users.filter(
                                name => name !== currentUserName
                            );

                            // Remove reaction type if count is 0
                            if (message.reactions[reactionType].count === 0) {
                                this.$delete(message.reactions, reactionType);
                            }
                        }
                    } else {
                        // Add reaction
                        if (message.reactions[reactionType]) {
                            message.reactions[reactionType].count++;
                            message.reactions[reactionType].currentUserReacted = true;
                            if (!message.reactions[reactionType].users.includes(currentUserName)) {
                                message.reactions[reactionType].users.push(currentUserName);
                            }
                        } else {
                            this.$set(message.reactions, reactionType, {
                                count: 1,
                                users: [currentUserName],
                                currentUserReacted: true
                            });
                        }
                    }
                }

                // Show subtle feedback (removed persistent alert)
            } catch (error) {
                console.error('Failed to add reaction:', error);
                this.showAlert('danger', 'Failed to add reaction. The API endpoint may not be implemented yet.');
            }
        },

        getReactionIcon(type) {
            const iconMap = {
                'heart': ['fas', 'heart'],
                'thumbs-up': ['fas', 'thumbs-up'],
                'thumbs-down': ['fas', 'thumbs-down'],
                'laugh': ['far', 'face-laugh-beam'],
                'warning': ['fas', 'triangle-exclamation'],
                'question': ['fas', 'circle-question'],
                'celebrate': ['fas', 'party-horn']
            };
            return iconMap[type] || ['fas', 'heart'];
        },

        initializeMessageReactions(message) {
            // Initialize reactions object if it doesn't exist
            if (!message.reactions) {
                this.$set(message, 'reactions', {});
            }
        },

        isMessageOwner(message) {
            // Check if the current user is the author of the message
            const currentUserName = localStorage.getItem('name');
            return message.author === currentUserName;
        }
    }
};


</script>
<style>
.ck-editor__editable {
    min-height: 120px !important;
    max-height: 300px !important;
    overflow-y: auto !important;
}

.image img {
    width: 100%;
    height: auto;
}

.chatlog table {
    width: 100% !important;
}

.message-actions {
    cursor: pointer;
    transition: opacity 0.2s;
}

.action-icon {
    margin: 0 8px;
    cursor: pointer;
    transition: transform 0.2s, color 0.2s;
}

.action-icon:hover {
    transform: scale(1.2);
    color: #007bff;
}

.action-icon.text-danger:hover {
    color: #dc3545 !important;
    transform: scale(1.2);
}

.reactions-display {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
}

.reaction-badge {
    cursor: pointer;
    padding: 4px 10px;
    font-size: 14px;
    transition: all 0.2s;
    user-select: none;
}

.reaction-badge:hover {
    transform: scale(1.1);
    box-shadow: 0 2px 4px rgba(0,0,0,0.2);
}

.reaction-badge.badge-primary {
    background-color: #007bff;
    color: white;
    font-weight: bold;
}

.reaction-badge.badge-light {
    background-color: #f8f9fa;
    color: #6c757d;
    border: 1px solid #dee2e6;
}

.reaction-badge.badge-light:hover {
    background-color: #e9ecef;
    border-color: #007bff;
}
</style>